/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState } from "react";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import { useDispatch } from "react-redux";
const FilterDropdown = ({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    options,
    data_testid,
    handleSelect,
    filterValues,
    filterKey,
    handleSelectAll,
    handleClear,
    
}) => {
    const ref = useRef();
    const dispatch = useDispatch();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    


    // useOnClickOutside(ref, () => {
    //     setIsOpen(false);
    // });

    const toSnakeCase = (str) => {
        return str.replace(/\s+/g, '_').toLowerCase();
    };


    
   
    return (
        <div className='relative' ref={ref}>
            <p htmlFor={id} className='text-xs font-semibold text-[#000] pb-1.5'>{label}</p>
            
            <button
                ref={buttonRef}
                data-testid={data_testid}
                onClick={() => setIsOpen(!isOpen)}
                className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA]'} rounded-lg px-3.5 py-[12px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                disabled={disabled}
            >
                <p id={id} className={`${!value ? 'text-[#52555D]' : 'text-[#000B17]'} text-start text-sm more-lines`}>
                    {!value ? placeholder : value}
                </p>
                <img
                    loading='lazy'
                    decoding='async'
                    src="/images/dropdown_green.svg"
                    alt="icon"
                    className={`${isOpen ? "transform rotate-180" : ""}`}
                />
            </button>
            
            <ul className={`py-4 pr-1 pl-4 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                <li>
                    <ul>
                        <li className='flex justify-between items-center p-2 pr-4'>
                            <div className="relative checkbox custom-checkBoxBlue1">
                                <input
                                    type="checkbox"
                                    id={`select_all_${filterKey}`}
                                    data-testid={`select_all_${filterKey}`}
                                    checked={filterValues[filterKey]?.length === options?.length}
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                    className='prevent-click'
                                />
                                <label
                                    htmlFor={`select_all_${filterKey}`}
                                    className='text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4'
                                >
                                    Select All
                                </label>
                            </div>
                            {options?.length > 0 && (
                                <button
                                    onClick={handleClear}
                                    type='button'
                                    className={`text-xs font-semibold text-[#008586] ${filterValues[filterKey]?.length > 0 ? 'ml-auto' : 'hidden'}`}
                                >
                                    Clear All
                                </button>
                            )}
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <ul className='max-h-[100vh-497px] overflow-auto scrollbar_gray pr-3'>
                                {options?.map((item, idx) => (
                                    <li key={idx} className='flex justify-between items-center p-2'>
                                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                            <input
                                                type="checkbox"
                                                id={item}
                                                data-testid={data_testid}
                                                onChange={() => handleSelect(item)}
                                                checked={
                                                    filterValues[filterKey]?.includes(item.trim()) || 
                                                    filterValues[filterKey]?.includes(toSnakeCase(item))
                                                }
                                                className='prevent-click'
                                            />
                                            <label
                                                htmlFor={item}
                                                className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                            >
                                                {item}
                                            </label>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
}

export default FilterDropdown;
